import classnames from 'classnames'
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone'
export interface AccordionItemProps {
  onToggle: () => void
  open: boolean
  title: string
  content: string
}

export const AccordionItem: React.FC<AccordionItemProps> = ({ onToggle, open, title, content, ...props }) => {
  const contentClasses = {
    'accordion-content': true,
    'accordion-open': open,
  }
  return (
    <div className="accordion-item" >
      <div className="accordion-title d-flex" onClick={onToggle}>
        <div className="mr-4">
          <AddCircleOutlineTwoToneIcon />&nbsp;
        </div>
        <div>
          {title}
        </div>
        </div>
      <div className={classnames(contentClasses)} aria-expanded={open}>
        {content}
      </div>
    </div>
  )
}